export const IGNORE_PATTERNS = [
  // "419": "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.",
  // "421": "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.",
  // "422": "There was an error while hydrating this Suspense boundary. Switched to client rendering.",
  // "425": "Text content does not match server-rendered HTML.",
  // https://github.com/facebook/react/blob/main/scripts/error-codes/codes.json
  /Minified React error #(?:418|419|421|422|423|425)/,
  /Load failed/,
  /Script error/,
  /Unexpected token/,
  /globalThis/,
  /parentNode/,
  /undefined is not an object \(evaluating 'response.msg'\)/,

  // 調査：https://ikyu.atlassian.net/browse/RES-458
  /Map: Expected mapDiv of type HTMLElement but was passed null\./,
  /Type error/, // TypeError: Type errorの場合に無視する
  /Could not load "marker"\./,
  /Cannot read properties of null \(reading 'disconnect'\)/,
  /キャンセルしました/,
  /The Google Maps JavaScript API could not load\./,
  /__gCrWeb.instantSearch.clearHighlight/,
  /Could not load "util"\./,
  /Could not load "map"\./,
  /Abort due to cancellation of share\./,
  /AbortError: Share canceled/,
  /HierarchyRequestError/,
  /No error message /,
  /Failed to initialize WebGL/,

  // This Suspense boundary received an update before it finished hydrating/,
  //
  // Remix になって大量に出るようになったエラー
  // React 18.3.0 で解消される予定だが、リリースがまだなので一旦無視する
  // @see https://github.com/remix-run/remix/issues/4822#issuecomment-1672040945
  //
  // React のエラーは Sentry が気を効かせて展開しているようなので下記に従い URL を追加する
  // https://github.com/getsentry/sentry-javascript/issues/6295#issuecomment-1337288091
  // https://github.com/getsentry/sentry-javascript/issues/6295#issuecomment-1359931115
  'https://reactjs.org/docs/error-decoder.html?invariant=418',
  'https://reactjs.org/docs/error-decoder.html?invariant=419',
  'https://reactjs.org/docs/error-decoder.html?invariant=421',
  'https://reactjs.org/docs/error-decoder.html?invariant=422',
  'https://reactjs.org/docs/error-decoder.html?invariant=423',
  'https://reactjs.org/docs/error-decoder.html?invariant=425',

  // なぜか GetCourseList を中心に fetch が失敗することが多い...
  /Network request failed/,
  /Failed to fetch/,
  /Fetch is aborted/,
  /GetCourseList GraphQL Error \(Code: 503\)/,
  /status=503/,

  // https://ikyu.sentry.io/issues/5091791666/?referrer=github_integration
  /reservableVisitorsCounts/,

  // FIXME: JSONLDに変更したら削除する
  // https://ikyu.sentry.io/issues/5056965552/?referrer=github_integration
  /extractFilteredSchemaValuesFromMicroData/,
  /Attempted to assign to readonly property./,

  // TODO ClientError の扱いは別途考える
  /予約可能な席がありません/,
]
